<template>
  <div class="modal-out">
    <div class="modal" style="width: 1200px;">
      <div class="modal-header">
        <div class="title">健康数据</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-row>

          <el-col :span='4'>
            <el-card class="box-card" shadow="never" :style="{height:(th+90)+'px'}" :body-style='{padding:"0px"}'  style="margin: 0px 0px 0px 10px;">
              <div slot="header" class="clearfix">
                <span style="font-size:18px;font-weight: bold;">老人信息</span>
                <el-button style="float: right; padding: 3px 0" type="text" icon="el-icon-refresh" @click="getElderlyRearsh">刷新</el-button>
              </div>
              <div style="padding:10px 0">
                <el-input placeholder="输入老人姓名" size="mini" v-model="name" clearable style="width:120px;margin: 0px 3px;" ></el-input>
                <el-button style="padding:6px 5px;" type="primary" @click="getElderly(true)" size="mini">搜索</el-button>
              </div>
              <el-table v-loading="loading" stripe ref="elderlyTable" :data="elderlyInfo" :height="th-70" border style="width: 100%;">
                <el-table-column fixed prop="fullName" label="老人姓名"></el-table-column>

                <!--                              <el-table-column prop="phoneNumber" label="手机号"></el-table-column>-->
                <!--                              <el-table-column prop="cardNumber" label="身份证号"></el-table-column>-->

                <!--                              <el-table-column prop="registerTime" label="登记时间" :formatter="getTime"></el-table-column>-->

                <el-table-column fixed="right" label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" @click="examInfo(scope.row)">详情</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  :current-page.sync="currentPage"
                  :page-size="20"
                  small
                  background
                  layout="total, prev, next"
                  :total="totalItems"
                  @current-change="current_change"
                  style="padding-top:13px;width: 20px;">
              </el-pagination>
            </el-card>
          </el-col>

          <el-col :span='20'>

            <el-card class="box-card exam" shadow="never" :body-style='{overflow: "auto",height:(th+8)+"px",paddingTop:"0px"}' style="margin: 0px 10px 0px 10px;">

              <div slot="header" class="clearfix">
                <span style="font-size:18px;font-weight: bold;">检测信息</span>
                <el-button style="float: right; padding: 3px 0" type="text" icon="el-icon-time" @click="openHistory">历史记录</el-button>
              </div>


              <div style="color:#409EFF;font-size:18px;font-weight: 600;margin:10px 10px 0;line-height:40px">
                <span>基本信息</span>
              </div>
              <el-row>
                <el-card class="box-card" shadow="never" :body-style='{padding:"0px"}'>
                  <el-col :span="item.row" v-for="(item,i) in gridList" :key="i">
                    <div>
                      <div style="color: gray;padding: 5px;">{{item.name}}</div>
                      <div style="padding: 5px;">{{item.value}}</div>
                      <div style="clear:both"></div>
                    </div>
                  </el-col>
                </el-card>

              </el-row>


              <el-row>
                <el-col :span="item.row" v-for="(item,i) in examList" :key="i">
                  <div style="color:#409EFF;font-size:18px;font-weight: 600;margin:10px 10px 0;line-height:40px">
                    <span>{{item.name}}</span>
                  </div>
                  <el-card class="box-card" shadow="never" :body-style='{padding:"0px"}'>
                    <div v-if="item.data">
                      <el-col :span="item1.row" v-for="(item1,j) in item.data" :key="j">
                        <div>
                          <div style="color: gray;padding: 5px;">{{item1.name}}</div>
                          <el-popover
                              v-if="item1.normal"
                              placement="top-start"
                              title="正常范围值"
                              trigger="hover"
                              :content="item1.normal">
                            <div slot="reference" style="padding: 5px;" :class="{gridRight:true,red:item1.red}">{{item1.value}}</div>
                          </el-popover>
                          <div v-else style="padding: 5px;">{{item1.value}}</div>
                          <div style="clear:both"></div>
                        </div>
                      </el-col>
                    </div>
                    <div v-else class="kong">
                      <span style="color:#999;padding: 10px;">暂无数据~</span>
                    </div>
                  </el-card>
                </el-col>
              </el-row>

            </el-card>
          </el-col>

        </el-row>
      </div>
    </div>

    <el-dialog title="历史记录" @open="getHistory" :visible.sync="dialogHistory"
               :modal-append-to-body='false'>
      <el-row>
        <el-col :span="24">
          <el-date-picker
              v-model="historyDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"
              @change="getHistoryList">
          </el-date-picker>
        </el-col>
        <el-col :span="item.row" v-for="(item,i) in historyList" :key="i">
          <div style="color:#409EFF;font-size:18px;font-weight: 600;margin:10px 10px 0;line-height:40px">
            <span>{{item.name}}</span>
          </div>
          <el-card class="box-card"  shadow="never"  :body-style='{padding:"0px"}'>
            <div v-if="item.data">
              <el-col :span="item1.row" v-for="(item1,j) in item.data" :key="j">
                <div>
                  <div style="color: gray;padding: 5px;">{{item1.name}}</div>
                  <el-popover
                      v-if="item1.normal"
                      placement="top-start"
                      title="正常范围值"
                      trigger="hover"
                      :content="item1.normal">
                    <div slot="reference" style="padding: 5px;" :class="{gridRight:true,red:item1.red}">{{item1.value}}</div>
                  </el-popover>
                  <div v-else style="padding: 5px;">{{item1.value}}</div>
                  <div style="clear:both"></div>
                </div>
              </el-col>
            </div>
            <div v-else class="kong">
              <span style="color:#999;padding: 10px;">暂无数据~</span>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>


  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import { getStaffDTO} from "@/utils/auth";

export default {
  name: 'GetElderly',
  data() {
    return {

      dialogHistory:false,
      historyDate:'',
      name:'',
      phone:'',
      loading: false,
      loadingInfo: false,

      elderly:null,

      elderlyInfo:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      bodyStyle:"height:"+(this.$store.state.tableHeight)+'px',
      th:this.$store.state.tableHeight,

      equipmentID:'',
      gridList:[],
      examList:[],
      historyList:[],

    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.bodyStyle = "height:"+(val+50)+'px';
      this.th=val
    },
  },

  methods: {
    init(row){
      this.gridList=[]
      this.examList=[]
      this.equipmentID=row.equipmentID
      this.getElderly()
    },
    closeSelf() {
      this.$emit("closeData");
    },

    openHistory(){
      if(this.elderly != null){
        this.dialogHistory=true;
      }else{
        this.$message.info("暂无选中的老人");
      }
    },
    getHistory(){
      let date=timefilters(new Date()).slice(0,10);
      this.historyDate=date;

      this.getHistoryList();
    },
    getHistoryList(){
      var list=[]
      var userId=this.elderly.uid
      this.getAxios("YqExamHeightWeight/GetByTime",userId).then(resolve=>{
        var data={row:24,name:'身高体重检测',data:null}
        if(resolve){
          data.data=[
            {row:8,name:'身高值',value:resolve.height+' cm'},
            {row:8,name:'体重值',value:resolve.weight+' kg'},
            {row:8,name:'BMI指数',value:resolve.bmi,normal:'18.5-23.9',red:resolve.bmi<18.5||resolve.bmi>23.9},
            {row:8,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:16,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.historyList=this.examListSort(list)
      })
      this.getAxios("YqExamBloodOxygen/GetByTime",userId).then(resolve=>{
        var data={row:24,name:'血氧检测',data:null}
        if(resolve){
          data.data=[
            {row:12,name:'血氧饱和度',value:resolve.spo2+' mmHg',normal:'90mmHg-100mmHg',red:resolve.bmi<90||resolve.bmi>100},
            {row:12,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:24,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.historyList=this.examListSort(list)
      })
      this.getAxios("YqExamBloodPressure/GetByTime",userId).then(resolve=>{
        var data={row:24,name:'血压检测',data:null}
        if(resolve){
          data.data=[
            {row:8,name:'收缩压',value:resolve.sbp+' mmHg',normal:'90mmHg-140mmHg',red:resolve.bmi<90||resolve.bmi>140},
            {row:8,name:'舒张压',value:resolve.dbp+' mmHg',normal:'60mmHg-90mmHg',red:resolve.bmi<60||resolve.bmi>90},
            {row:8,name:'脉率',value:resolve.pr+'次',normal:'60次-100次',red:resolve.bmi<60||resolve.bmi>100},
            {row:8,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:16,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.historyList=this.examListSort(list)
      })
      this.getAxios("YqExamBmd/GetByTime",userId).then(resolve=>{
        var data={row:24,name:'骨密度检测',data:null}
        if(resolve){
          var BodyPartList=['左','右']
          var ExamTypeList=['桡骨','胫骨']
          data.data=[
            {row:8,name:'年龄',value:resolve.age},
            {row:8,name:'性别',value:resolve.gender},
            {row:8,name:'检测的骨头类型',value:ExamTypeList[resolve.examType]},
            {row:8,name:'左右',value:BodyPartList[resolve.bodyPart]},
            {row:8,name:'声速值',value:resolve.sos},
            {row:8,name:'T值',value:resolve.tvalue},
            {row:8,name:'Z值',value:resolve.zvalue},
            {row:8,name:'百分比值',value:resolve.percentage},
            {row:8,name:'出生日期',value:resolve.birthDay},
            {row:8,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:16,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.historyList=this.examListSort(list)
      })
      this.getAxios("YqExamTemperature/GetByTime",userId).then(resolve=>{
        var data={row:24,name:'体温检测',data:null}
        if(resolve){
          data.data=[
            {row:12,name:'体温值',value:resolve.temperature+' ℃',normal:'36.3℃-37.2℃',red:resolve.bmi<36.3||resolve.bmi>37.2},
            {row:12,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:24,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.historyList=this.examListSort(list)
      })
      this.getAxios("YqExamWaistline/GetByTime",userId).then(resolve=>{
        var data={row:24,name:'腰/臀围检测',data:null}
        if(resolve){
          data.data=[
            {row:8,name:'腰围长度',value:resolve.waistLine},
            {row:8,name:'臀围长度',value:resolve.hip},
            {row:8,name:'腰臀比',value:resolve.ratio},
            {row:8,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:16,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.historyList=this.examListSort(list)
      })
    },


    examInfo(row){
      this.gridList=[]
      this.examList=[]
      this.elderly=row;
      this.setBaseInfo(row);
      this.getExamData(row.uid);
    },

    getElderlyRearsh(){
      this.name=''
      this.gridList=[]
      this.examList=[]
      this.getElderly()
    },



    getAxios(url,userId){
      return new Promise((resolve, reject) => {
        this.$axios({
          method: 'post',
          url: this.$deviceUrl+url,
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            equipmentID:this.equipmentID,
            userId:userId,
            checkTime:this.historyDate
          }
        }).then( (response)=> {
          if(response.data.error == 0){
            resolve(response.data.data);
          }else if(response.data.error == 1){
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          reject(error.data)
        });
      });
    },
    getTime(row,index,column){
      return timefilters(column)
    },


    setBaseInfo(row){

      this.gridList = [];

      var genderList=['未知','男','女']
      this.gridList.push(
          {row:8,name:'姓名',value:row.fullName},
          {row:8,name:'登记时间',value:timefilters(row.registerTime)},
          {row:8,name:'证件号',value:row.cardNumber},
          {row:8,name:'手机号',value:row.phoneNum},
          {row:8,name:'出生日期',value:timefilters(row.birthDay).slice(0,10)},
          {row:8,name:'性别',value:genderList[row.gender]},
          {row:8,name:'民族',value:row.nation},
          {row:16,name:'居住地址',value:row.address},
      );

    },
    getExamData(userId){
      var list=[]
      this.getAxios("YqExamHeightWeight/GetByLastTime",userId).then(resolve=>{
        var data={row:24,name:'身高体重检测',data:null}
        if(resolve){
          data.data=[
            {row:8,name:'身高值',value:resolve.height+' cm'},
            {row:8,name:'体重值',value:resolve.weight+' kg'},
            {row:8,name:'BMI指数',value:resolve.bmi,normal:'18.5-23.9',red:resolve.bmi<18.5||resolve.bmi>23.9},
            {row:8,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:16,name:'健康建议',value:resolve.checkResult},
          ]
        }
        // this.examList.push(data)
        list.push(data)
        this.examList=this.examListSort(list)
      })
      this.getAxios("YqExamBloodOxygen/GetByLastTime",userId).then(resolve=>{
        var data={row:24,name:'血氧检测',data:null}
        if(resolve){
          data.data=[
            {row:12,name:'血氧饱和度',value:resolve.spo2+' mmHg',normal:'90mmHg-100mmHg',red:resolve.bmi<90||resolve.bmi>100},
            {row:12,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:24,name:'健康建议',value:resolve.checkResult},
          ]
        }
        // this.examList.push(data)
        list.push(data)
        this.examList=this.examListSort(list)
      })
      this.getAxios("YqExamBloodPressure/GetByLastTime",userId).then(resolve=>{
        var data={row:24,name:'血压检测',data:null}
        if(resolve){
          data.data=[
            {row:8,name:'收缩压',value:resolve.sbp+' mmHg',normal:'90mmHg-140mmHg',red:resolve.bmi<90||resolve.bmi>140},
            {row:8,name:'舒张压',value:resolve.dbp+' mmHg',normal:'60mmHg-90mmHg',red:resolve.bmi<60||resolve.bmi>90},
            {row:8,name:'脉率',value:resolve.pr+'次',normal:'60次-100次',red:resolve.bmi<60||resolve.bmi>100},
            {row:8,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:16,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.examList=this.examListSort(list)
      })
      this.getAxios("YqExamBmd/GetByLastTime",userId).then(resolve=>{
        var data={row:24,name:'骨密度检测',data:null}
        if(resolve){
          var BodyPartList=['左','右']
          var ExamTypeList=['桡骨','胫骨']
          data.data=[
            {row:8,name:'年龄',value:resolve.age},
            {row:8,name:'性别',value:resolve.gender},
            {row:8,name:'检测的骨头类型',value:ExamTypeList[resolve.examType]},
            {row:8,name:'左右',value:BodyPartList[resolve.bodyPart]},
            {row:8,name:'声速值',value:resolve.sos},
            {row:8,name:'T值',value:resolve.tvalue},
            {row:8,name:'Z值',value:resolve.zvalue},
            {row:8,name:'百分比值',value:resolve.percentage},
            {row:8,name:'出生日期',value:resolve.birthDay},
            {row:8,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:16,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.examList=this.examListSort(list)
      })
      this.getAxios("YqExamTemperature/GetByLastTime",userId).then(resolve=>{
        var data={row:24,name:'体温检测',data:null}
        if(resolve){
          data.data=[
            {row:12,name:'体温值',value:resolve.temperature+' ℃',normal:'36.3℃-37.2℃',red:resolve.bmi<36.3||resolve.bmi>37.2},
            {row:12,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:24,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.examList=this.examListSort(list)
      })
      this.getAxios("YqExamWaistline/GetByLastTime",userId).then(resolve=>{
        var data={row:24,name:'腰/臀围检测',data:null}
        if(resolve){
          data.data=[
            {row:8,name:'腰围长度',value:resolve.waistLine},
            {row:8,name:'臀围长度',value:resolve.hip},
            {row:8,name:'腰臀比',value:resolve.ratio},
            {row:8,name:'检测时间',value:timefilters(resolve.checkTime)},
            {row:16,name:'健康建议',value:resolve.checkResult},
          ]
        }
        list.push(data)
        this.examList=this.examListSort(list)
      })
    },
    examListSort(list){
      if(list.length==6){
        list.sort(function (a, b) {
          var a1='1970'
          var b1='1970'
          if(a.data){
            a.data.forEach(element => {
              if(element.name=='检测时间'){
                a1=element.value
              }
            });
          }
          if(b.data){
            b.data.forEach(element => {
              if(element.name=='检测时间'){
                b1=element.value
              }
            });
          }
          return new Date(b1).getTime()-new Date(a1).getTime();
        })
        return list;
      }
      return []
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getElderly();
    },
    getElderly(init){
      if(init==true){this.currentPage=1}
      this.loading = true;

      let insCode = getStaffDTO().institutionDTO.institutionCode;

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"YqUser/InsPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          equipmentID:this.equipmentID,
          name:this.name,
          institutionCode:insCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {

              this.elderlyInfo=response.data.data.list;
              this.totalItems = response.data.data.total;

              this.$nextTick(()=>{
                this.$refs.elderlyTable.doLayout()
              })

              if(this.elderlyInfo.length>0){
                this.setBaseInfo(this.elderlyInfo[0])
                this.elderly=this.elderlyInfo[0]
                this.getExamData(this.elderlyInfo[0].uid);
              }

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
